import {FC} from 'react'
import {useLocation} from 'react-router'
import {Link, useNavigate} from 'react-router-dom'
import clsx from 'clsx'
import {checkIsActive, KTSVG} from '../../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasArrow?: boolean
  hasBullet?: boolean
  pathExact?: boolean
}

const MenuItem: FC<Props> = ({to, title, icon, fontIcon, hasArrow = false, hasBullet = false, pathExact = false}) => {
  const {pathname} = useLocation()
  const navigate = useNavigate()

  return (
    <div className='menu-item me-1'>
      <span
        className={clsx('menu-link py-3', {
          'active menu-here': checkIsActive(pathname, to, pathExact),
        })}
        // to={to}
        onClick={() => navigate(to)}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}

        {icon && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}

        {fontIcon && (
          <span className='menu-icon'>
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}

        <span className='menu-title'>{title}</span>

        {hasArrow && <span className='menu-arrow'></span>}
      </span>
    </div>
  )
}

export {MenuItem}
